import { useEffect, useState } from 'react';
import { api } from '../lib/api';

type TargetType = 'discussion' | 'chat' | 'task_comment' | 'dashboard_message' | 'meeting';

type ReactionsMap = Record<number, Record<string, { count: number; by_me: boolean }>>;

const QUICK_EMOJIS = ['✓', '?', '👍', '🎯'];

export function useReactions(targetType: TargetType, targetIds: number[]) {
  const [reactions, setReactions] = useState<ReactionsMap>({});

  async function refresh() {
    if (targetIds.length === 0) {
      setReactions({});
      return;
    }
    const ids = targetIds.join(',');
    const r = await api.get<{ reactions: ReactionsMap }>(
      `/reactions?target_type=${targetType}&ids=${encodeURIComponent(ids)}`
    );
    setReactions(r.reactions);
  }

  useEffect(() => {
    refresh();
  }, [targetType, targetIds.join(',')]);

  async function toggle(targetId: number, emoji: string) {
    await api.post('/reactions/toggle', {
      target_type: targetType,
      target_id: targetId,
      emoji,
    });
    refresh();
  }

  return { reactions, toggle, refresh };
}

export function ReactionRow({
  emojis,
  onToggle,
}: {
  emojis: Record<string, { count: number; by_me: boolean }>;
  onToggle: (emoji: string) => void;
}) {
  return (
    <div className="reaction-row">
      {Object.entries(emojis).map(([e, d]) => (
        <button
          key={e}
          className={`reaction-chip ${d.by_me ? 'active' : ''}`}
          onClick={() => onToggle(e)}
          title={d.by_me ? 'Retirer' : 'Ajouter ta réaction'}
        >
          {e} <span className="card-meta">{d.count}</span>
        </button>
      ))}
      <div className="reaction-quick">
        {QUICK_EMOJIS.filter((q) => !(q in emojis)).map((q) => (
          <button
            key={q}
            className="reaction-chip ghost"
            onClick={() => onToggle(q)}
            title={`Réagir ${q}`}
          >
            {q}
          </button>
        ))}
      </div>
    </div>
  );
}
